// Components
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

type TableSkeletonType = {
  numOfRows: number;
};

const TableSkeleton = ({ numOfRows }: TableSkeletonType) => {
  return (
    <Box
      display="flex"
      width="100%"
      flexDirection="column"
      alignItems="center"
      gap="12px"
    >
      <Skeleton
        variant="rounded"
        width="100%"
        height={24}
        sx={{
          borderRadius: "8px",
        }}
      />
      {Array.from({
        length: numOfRows,
      })?.map((_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          width="100%"
          height={57.5}
          sx={{
            borderRadius: "8px",
          }}
        />
      ))}
      <Skeleton
        variant="rounded"
        width={342}
        height={32}
        sx={{
          borderRadius: "8px",
          mt: "12px",
        }}
      />
    </Box>
  );
};

export default TableSkeleton;
